import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../components/Logo/Logo';
import LoginPageHeader from '../../components/LoginPageHeader/LoginPageHeader';
import Toast from '../../shared/components/Toast/Toast';
import Appetize from './Appetize/Appetize';
import { LoginForm } from './LoginForm/LoginForm';
import { LoginQuestionsModal } from './LoginQuestionsModal/LoginQuestionsModal';
import { ForgotPasswordModal } from './ForgotPasswordModal/ForgotPasswordModal';
import {
    getIdentityProvidersAction,
    getLoginPageLogoAction,
    getSSOLoginErrorMessageAction,
} from '../../actions/actionCreators';
import { hideErrorStatusAction } from '../../shared/actions/actionCreators';
import { getCompanyLogo, getActiveDialog, getAppetizePreferences } from '../../selectors/login';
import { getErrorCode, getErrorMessage } from '../../shared/selectors/errorStatus/errorStatus';
import {
    LOGIN_QUESTIONS,
    FORGOT_PASSWORD,
} from '../../constants/constants';
import './Login.css';
import { getAppetizePreferenceAction } from '../../slices';

export const Login = () => {
    const dispatch = useDispatch();
    const ssoErrorCode = useSelector(getErrorCode);
    const ssoErrorMessage = useSelector(getErrorMessage);
    const activeDialog = useSelector(getActiveDialog);
    const companyLogoURL = useSelector(getCompanyLogo);
    const appetizePreferences = useSelector(getAppetizePreferences);

    useEffect(() => {
        dispatch(getLoginPageLogoAction());
        dispatch(getIdentityProvidersAction());
        dispatch(getSSOLoginErrorMessageAction());
        dispatch(getAppetizePreferenceAction());
    }, [dispatch]);

    const onDismissButtonClick = () => {
        dispatch(hideErrorStatusAction());
    };

    return (
        <div className="loginPageWrapper">
            <LoginPageHeader />
            <Toast
                type="error"
                isHidden={!ssoErrorCode}
                errorCode={ssoErrorCode}
                errorMessage={ssoErrorMessage}
                dismissButtonClick={onDismissButtonClick}
            />
            <div className="loginPageContent">
                <div className="companyLogoWrapper">
                    <Logo className="companyLogo" url={companyLogoURL} alt="companyLogo" />
                </div>
                <div className="loginPanelWrapper">
                    <div className="loginPanel">
                        <LoginForm />
                    </div>
                    <div className="loginPanel appetizePanels">
                        {Object.keys(appetizePreferences).length > 0
                        && Object.keys(appetizePreferences).map((item) => (
                            <Appetize appConfig={appetizePreferences[item]} />
                        ))}
                    </div>
                </div>
                <LoginQuestionsModal show={activeDialog === LOGIN_QUESTIONS} />
                <ForgotPasswordModal show={activeDialog === FORGOT_PASSWORD} />
            </div>
        </div>
    );
};

export default Login;
